import { useState } from "react";

import LoadingSpinner from "../../../../../Account/LoadingSpinner/LoadingSpinner";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmarkCircle } from "@fortawesome/free-solid-svg-icons";

import { Carousel } from "react-responsive-carousel";

import styles from './styles.module.scss';

export default function CardCarousel({ listingImages }) {

    const sortedImages = listingImages === null && listingImages !== undefined ? [] : listingImages.sort((a, b) => a.position - b.position)

    const CarouselImages = ({ url, expanded }) => {
        const [imageLoaded, setImageLoaded] = useState(false);
        return (
            <div id={styles.imgWrapper} style={{ cursor: expanded === true ? 'default' : 'pointer' }}>
                {
                    imageLoaded === false &&
                    <span style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: '2', backgroundColor: '#000000' }}>
                        <LoadingSpinner type="pulse" color="#FFFFFF" />
                    </span>
                }
                <div id={styles.frontImg}>
                    <img onLoad={() => setImageLoaded(true)} src={url} />
                </div>
                
                <div id={styles.blurImg}>
                    <img src={url} alt={url} />
                </div>
            </div>
        );
    }

    const [expandedSlider, showExpandedSlider] = useState(false);

    const ExpandedSlider = () => {

        return (
            <section id={styles.popupSlider}>
                <FontAwesomeIcon onClick={() => showExpandedSlider(false)} icon={faXmarkCircle} id={styles.exitCarousel} />
                <Carousel className={styles.popupCarousel} autoPlay={true} dynamicHeight={false} emulateTouch={true} infiniteLoop={true} interval={4000} preventMovementUntilSwipeScrollTolerance={true} showArrows={true} swipeable={true} >
                    { sortedImages.map((image, index) => {
                        return <CarouselImages key={index} url={image.url} expanded={true} />
                    }) }
                </Carousel>
            </section>
        )
    }

  return (
    <section id={styles.cardCarouselWrapper}>
        { expandedSlider === true && <ExpandedSlider /> }
        <Carousel className={styles.mainCarousel} onClickItem={() => showExpandedSlider(true)} autoPlay={true} dynamicHeight={false} emulateTouch={true} infiniteLoop={true} interval={4000} preventMovementUntilSwipeScrollTolerance={true} showArrows={false} showThumbs={false} showIndicators={false} showStatus={false} swipeable={true} >
        { sortedImages !== null && sortedImages !== undefined && sortedImages.map((image, index) => {
            return <CarouselImages key={index} url={image?.url || image} expanded={false} />
        }) }
        </Carousel>
    </section>

  )
}